import { orderService } from '@/api'
import { appUser, storage } from '@/utils'
import { AsyncRequest } from '@/utils/request'
import { $paySuccess } from '@/utils/common/native-api'
import { Indicator } from 'mint-ui'
import { createPreMultiOrder, createMultiOrder } from '@/api/modules/goods/physical.js'

const state = {
  // 预付订单
  preOrder: {
    isEmpty: true,
    buyNum: 1, // 默认购买一个
    goodsInfo: {}, // 商品
    couponList: [], // 优惠券列表
    discountList: [], // 扣减列表
    installList: [] // 分期方案列表
  },
  ratio: 100,
  discountIntegralReal: 0,
  // 抵扣商品列表
  disCountOrderList: {
    discountTotal: 0, // 总金额
    discountInfoList: [] // 列表
  },
  paymethod: 1, // 支付方式
  installment: { installmentId: 0 }, // 选择的分期
  openByStages: 0,
  coupon: {},
  // 开始支付的订单
  order:
    {
      appid: 'wxf56d7d93bc226f2e',
      noncestr: 'VKGwV26t3GdJWf2i',
      package: 'Sign=WXPay',
      partnerid: '1433913602',
      sign: '9E3D094A69A9A8CCD2963B0B19115692',
      timestamp: 1592903239,
      prepayid: null
    } || {},
  orderLog: [],
  // 支付状态
  payStatus: {
    status: 0 // 测试标记为支付成功
  },
  showConfirm: false // 是否显示微信支付之后的确认弹窗
}

// eslint-disable-next-line no-unused-vars
function getDefaultOrder() {
  return {
    // 分期的列表，是按照补差价之后计算过的
    installList: [
      {
        installmentId: 1,
        downPayments: 10.0,
        installmentNum: 5,
        installmentAmount: 18,
        goodsPrice: 100,
        name: '商品分期1一'
      },
      {
        installmentId: 2,
        downPayments: 6.0,
        installmentNum: 5,
        installmentAmount: 18,
        goodsPrice: 100,
        name: '商品分期1一'
      },
      {
        installmentId: 3,
        downPayments: 5.0,
        installmentNum: 5,
        installmentAmount: 18,
        goodsPrice: 100,
        name: '商品分期1一'
      },
      {
        installmentId: 4,
        downPayments: 10.0,
        installmentNum: 5,
        installmentAmount: 18,
        goodsPrice: 100,
        name: '商品分期1一'
      }
    ],
    orderAmount: 15,
    isNeedAddress: true,
    // 分期的订单金额
    orderInstallmentAmount: 100.0,
    // 优惠券列表
    // 'couponList': [],
    couponList: [
      {
        effectiveStartTime: '2020-06-11T14:57:23.000+0000',
        couponDiscount: 8,
        name: '5折优惠券',
        limitAmount: 200.0,
        effectiveEndTime: '2020-06-21T14:57:28.000+0000',
        id: 1,
        type: 1, // 0 立减 1 折扣
        maxAmount: 8,
        content: 5,
        status: 1
      },
      {
        effectiveStartTime: '2020-06-11T14:57:23.000+0000',
        couponDiscount: 100,
        name: '7.5折优惠券',
        limitAmount: 100.0,
        effectiveEndTime: '2020-06-21T14:57:28.000+0000',
        id: 2,
        type: 1, // 0 立减 1 折扣
        maxAmount: 200,
        content: 75,
        status: 1
      }
    ],
    discountList: [
      { orderSn: 'code', goodsName: '生活口语指南', realPayAmount: 23.11, goodsNum: 1 },
      { orderSn: 'code', goodsName: '职场幸福哲学', realPayAmount: 23.11, goodsNum: 1 },
      { orderSn: 'code', goodsName: '职场幸福哲学', realPayAmount: 23.11, goodsNum: 1 },
      { orderSn: 'code', goodsName: '职场幸福哲学', realPayAmount: 23.11, goodsNum: 1 },
      { orderSn: 'code', goodsName: '职场幸福哲学', realPayAmount: 23.11, goodsNum: 1 },
      { orderSn: 'code', goodsName: '职场幸福哲学', realPayAmount: 23.11, goodsNum: 1 }
    ],
    // 商品信息
    goodsInfo: {
      goodsIcon: 'https://img-cdn1.ylyk.com/image/1589873957956.jpg',
      goodsId: 20,
      goodsPrice: 100.0,
      goodsName: '自定义专辑测11',
      goodsNum: 1
    }
  }
}

const getters = {
  preOrder: state => state.preOrder,
  disCountOrderList: state => state.disCountOrderList,
  order: state => state.order,
  payStatus: state => state.payStatus,
  paymethod: state => state.paymethod, // 支付方式
  openByStages: state => state.openByStages, // 是否开启分期
  installment: state => state.installment, // 选择的分期
  coupon: state => state.coupon,
  orderLog: state => state.orderLog,
  showConfirm: state => state.showConfirm,
  ratio: state => state.ratio,
  discountIntegralReal: state => state.discountIntegralReal
}

const mutations = {
  // 积分抵扣数
  setdiscountIntegralReal: (state, num) => {
    console.log('state积分抵扣数更新----', num)
    state.discountIntegralReal = num
  },
  // 设置预付订单（已获取预付单）
  setPreOrder: (state, preOrder) => {
    const { couponList = [], goodsInfo } = preOrder
    preOrder.couponList = couponList
    if (preOrder.goodsInfoList) {
      state.preOrder = preOrder
    } else if (preOrder.goodsId == null && goodsInfo && goodsInfo.goodsId > 0) {
      const { errorCode } = preOrder
      // 有错误订单，补充格式
      if (errorCode && errorCode !== 0) {
        //
      }
      // 切换分期
      // preOrder.installList.forEach(item => {
      //   item.useCoupon = 1
      // })
      state.preOrder = preOrder
    } else {
      // ?
      // if (appUser.userId === 5407446) state.preOrder = getDefaultOrder()
    }
    // 匹配到的优惠券
    const [coupon] =
      state.preOrder.couponList.filter(item => {
        const invalid = item.status === 0
        return !invalid
      }) || []
    state.coupon = coupon || {}
  },
  // 抵扣列表
  setDisCountOrderList: (state, orderList) => {
    state.disCountOrderList = orderList
  },
  setOrder: (state, order) => {
    state.order = order
  },
  getPayStatus: (state, { goodsId } = {}) => {
    const payStatus = storage.PaymentPayStatus(goodsId).getItem()
    console.log(payStatus, 'getpayStatus111')
    if (goodsId) {
      state.payStatus = payStatus
    }
  },
  setPayStatus: (state, payStatus) => {
    console.log(state, payStatus, 'state, payStatus')
    state.payStatus = payStatus
    storage.PaymentPayStatus(payStatus.goodsId).setItem(payStatus)
  },
  setCurrentOrder: (state, order) => {
    console.log(order, 'order206')
    storage.OrderMsg().setItem({ ...state, order })
  },
  setOrderLog: (state, log) => {
    // 订单的用户信息
    state.orderLog = [appUser, log]
  },
  // 设置付款方式和分期
  setPaymethod: (state, options) => {
    const { paymethod } = options
    state.paymethod = paymethod // 用户选择的支付方式
  },
  // 开启分期，设置分期
  setbyStages: (state, options) => {
    const { openByStages, installment } = options
    state.openByStages = openByStages
    if (!state.openByStages) {
      // 如果用户的操作是关闭分期
      state.installment = {} // 清空分期信息
    } else {
      // 如果用户开启了分期
      state.discountIntegralReal = 0 // 清空积分抵扣数
      if (installment != null) {
        // 有分期信息，月供
        state.installment = options.installment
      }
    }
  },
  setInstallment(state, installment) {
    state.installment = installment
  },
  // 设置优惠券（选择使用）
  setCoupon: (state, item) => {
    state.coupon = item
  },
  setPopShow(state, showConfirm) {
    state.showConfirm = showConfirm
  }
}

const actions = {
  // 预创建订单和创建订单
  preCreate({ commit, state }, data) {
    data.num = state.preOrder.buyNum
    if (data.goodsId <= 0) {
      commit('setPreOrder', data)
      return
    }
    return AsyncRequest({
      loading: true,
      request: () => orderService.preCreate(data),
      resolve: preOrder => commit('setPreOrder', preOrder),
      reject: error => commit('setPreOrder', error.data) // 只包括商品
    })
  },
  // 预创建订单和创建订单
  preCreateMini({ commit, state }, data) {
    data.num = data.num || state.preOrder.buyNum
    if (data.goodsId <= 0) {
      commit('setPreOrder', data)
      return
    }
    return AsyncRequest({
      loading: true,
      request: () => orderService.preCreateMini(data),
      resolve: preOrder => commit('setPreOrder', preOrder),
      reject: error => commit('setPreOrder', error.data) // 只包括商品
    })
  },
  preCreateByLimit({ commit, state }, data) {
    data.num = state.preOrder.buyNum
    if (data.goodsId <= 0) {
      commit('setPreOrder', data)
      return
    }
    return AsyncRequest({
      loading: true,
      request: () => orderService.preCreateByLimit(data),
      resolve: preOrder => commit('setPreOrder', preOrder),
      reject: error => commit('setPreOrder', error.data) // 只包括商品
    })
  },
  // 预创建组合实物订单和创建订单
  preCreateGoodsPhysical({ commit, state }, data) {
    data.num = 1

    return AsyncRequest({
      loading: true,
      request: () => createPreMultiOrder(data),
      resolve: preOrder => commit('setPreOrder', preOrder),
      reject: error => commit('setPreOrder', error.data) // 只包括商品
    })
  },
  // 创建订单
  createGoodsPhysical({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => createMultiOrder(data),
      resolve: order => commit('setOrderLog', order),
      reject: error => commit('setOrderLog', error.data)
    })
  },

  // 预创建订单和创建订单
  getDisCountOrderList({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => orderService.getDisCountOrderList(data),
      resolve: orderList => commit('setDisCountOrderList', orderList)
    })
  },
  // 创建订单
  create({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => orderService.create(data),
      resolve: order => commit('setOrderLog', order),
      reject: error => commit('setOrderLog', error.data)
    })
  },
  // 创建积分商品购买订单 2022年06月15日
  createIntegral({ commit }, data) {
    data.payType = 'YD'
    return AsyncRequest({
      loading: true,
      request: () => orderService.createIntegral(data),
      resolve: order => commit('setOrderLog', order),
      reject: error => commit('setOrderLog', error.data)
    })
  },
  createMini({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => orderService.createMini(data),
      resolve: order => commit('setOrderLog', order),
      reject: error => commit('setOrderLog', error.data)
    })
  },
  createByLimit({ commit }, data) {
    return AsyncRequest({
      loading: true,
      request: () => orderService.createByLimit(data),
      resolve: order => commit('setOrderLog', order),
      reject: error => commit('setOrderLog', error.data)
    })
  },
  // 查询支付结果
  getPayStatus({ commit }, order) {
    return AsyncRequest({
      request: () => orderService.getPayStatus(order),
      resolve: payStatus => {
        payStatus.goodsId = order.goodsId
        payStatus.isVipForever = order.isVipForever
        commit('setPayStatus', payStatus)
      }
    })
  },
  getPayStatusTime({ dispatch, commit }, order) {
    if (times.length === 0) setTimes()
    return new Promise((resolve, reject) => {
      Indicator.open('查询订单')

      // 构建订单参数
      const goodsId = order.goodsId
      const prePayId = order.paymentPrepayId || order.prepayid || order.prepay_id
      const isVipForever = order.isVipForever
      order = { goodsId, prePayId, isVipForever, orderSn: order.orderSn }

      const getPayStatus = (res, time) => {
        const commitLog = res => {
          commit('setOrderLog', {
            request: order,
            response: res
          })
        }
        dispatch('getPayStatus', order)
          .then(res => {
            const { status: payStatus } = res
            res.time = time
            commitLog(res)

            // 查询订单完成
            if (payStatus >= 1) {
              Indicator.close()
              // 通知原生支付结果
              if (appUser.isNative) {
                $paySuccess(order)
              }
              resolve(res)
            } else {
              gettime_setTimeout(res)
            }
          })
          .catch(error => {
            // Indicator.close() // 继续查询
            commitLog(error)
            gettime_setTimeout(res)
          })
      }

      const gettime_setTimeout = res => {
        const time = times.shift()
        // 查询订单无结果
        if (time == null) {
          Indicator.close()
          return resolve(res)
        }
        setTimeout(() => getPayStatus(res, time), time)
      }
      // 轮询查询订单状态
      gettime_setTimeout()
    })
  },
  // 取消了支付(请求即可)
  cancelOrder({ commit }, order) {
    const prepayId = order.paymentPrepayId || order.prepayid
    order = { prepayId }
    return AsyncRequest({
      request: () => orderService.cancelOrder(order)
    })
  }
}

let times = []
const setTimes = () => {
  times = [1000, 2000, 3000, 5000]
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
